//This file contains functions for use when rendering DOM elements
//in the todos section of the website.

import {getTodos, toggleTodo, removeTodo} from './todos-functions';
import {getFilters} from './todos-filters';

//Function to update filtered todos list.
const renderTodos = () => {
    //Clear old list.
    document.querySelector('#todos').innerHTML = '';

    //Get unfiltered list.
    const todos = getTodos();

    //Get destructured filters.
    const {hideCompleted, searchText} = getFilters();

    //Filter out conpleted todos if desired.
    const filteredList = todos.filter((todo) => {
        //Return false if item is completed and the checkbox to
        //Hide it is checked.
        if (todo.completed && hideCompleted) {
            return false;
        }

        //Now, filter by search box.
        return todo.text.toLowerCase().includes(
            searchText.toLowerCase());
    });

    //Make counter for uncompleted items.
    let incompleteCounter = 0;

    //Make array to hold tags.
    const tagArray = [];

    //loop through above filtered array.
    filteredList.forEach((todo) => {
        //If needed, increment counter.
        if(!todo.completed) {
            incompleteCounter++;
        }

        //Add tag to tag array.
        tagArray.push(generateTodoDom(todo));
    });

    //Create and add incomplete summary tag.
    const summaryTag 
        = generateSummaryDom(incompleteCounter, searchText);
    document.querySelector('#todos').appendChild(summaryTag);

    //Check if there aren't todos to show.
    if (!tagArray.length) {
        //Show "No To-dos" message.
        const messageTag = document.createElement('h2');
        messageTag.classList.add('empty-message');
        messageTag.textContent = 'There are no to-dos to show.';
        document.querySelector('#todos').appendChild(messageTag);

        //Exit function.
        return;
    }

    //Append tags from above lopp.
    tagArray.forEach((tag) => {
        document.querySelector('#todos').appendChild(tag);
    });
}

//Function to generate todo tag in DOM. (NOT exported.)
//Input: A single todo.
//Output: The <label> tag that shows the todo.
const generateTodoDom = (todo) => {
    //Define elements.
    const todoEl = document.createElement('label');
    const containerEl = document.createElement('div');
    const textEl = document.createElement('span');
    const buttonEl = document.createElement('button');
    const checkboxEl = document.createElement('input');

    //Set up checkbox.
    checkboxEl.setAttribute('type', 'checkbox');
    if (todo.completed) {
        checkboxEl.setAttribute('checked', 'checked');
    }
    checkboxEl.addEventListener('change', () => {
        toggleTodo(todo.id);
        renderTodos();
    });

    //Set content of text tag.
    textEl.textContent = todo.text;

    //Set up container element.
    containerEl.classList.add('list-item__container');
    containerEl.appendChild(checkboxEl);
    containerEl.appendChild(textEl);

    //Set up button.
    buttonEl.textContent = 'delete';
    buttonEl.classList.add('button');
    buttonEl.addEventListener('click', () => {
        removeTodo(todo.id);
        renderTodos();
    });

    //Constuct and return laber element.
    todoEl.classList.add('clickable-list-item');
    todoEl.appendChild(containerEl);
    todoEl.appendChild(buttonEl);
    return todoEl;
}

//Function to generate summary tag in DOM. (NOT exported.)
//Input: The current number of incomplete todos and the current
//search text from the filters object.
//Output: The <h2> tag that shows the summary.
const generateSummaryDom = (incompleteCounter, searchText) => {
    const summaryTag = document.createElement('h2');
    
    //Set test and style of tag.
    summaryTag.classList.add('user-message');
    const plural = incompleteCounter === 1 ? "" : "s";
    let summaryText = searchText
        ? `Your search has yielded ${incompleteCounter} `
        + `task${plural} to complete.`
        : `You have ${incompleteCounter} `
        + `task${plural} to complete.`;
    summaryTag.textContent = summaryText;

    //Return tag.
    return summaryTag;
}

//Export rendering function.
export {renderTodos};